(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('rfGlobalEnumDropdown', [RfFGlobalEnumDropdownDirectiveFn]);


    /* dropdown for enum-types */
    function RfFGlobalEnumDropdownDirectiveFn() {
        var directive = {
            link: link,
            restrict: 'E',
            scope: {
                enum: '=',
                enums: '=',
                required: '@?'
            },
            templateUrl: '/app/global/templates/rf-global-enum-dropdown.template.html'
        };
        return directive;

        function link(scope) {
            activate();

            // activate
            function activate() {
                if (scope.required) {
                    scope.required = scope.required === 'true';
                } // if
                else scope.required = false;
            }

            // reset
            scope.reset = function () {
                scope.enum = null;
            };

            // select
            scope.select = function (item) {
                scope.enum = item;
            };
        }
    }

})();